module.exports = __webpack_public_path__ + "static/media/BluePrint.db836d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collector/img/BluePrint.jpg
// module id = 61
// module chunks = 0